import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { formatPhoneNumberToInternational } from 'shared/lib'
import {
  type IParamsCreateContact,
  type IResponseContactUnifiedIntegration,
} from 'entities/Contacts/api/types'
import { ContactIntegrationBase } from 'entities/Contacts/model/Integrations/ContactIntegrationBase'
import type { IIntegrationKey, IIntegrationLinkDTO } from 'entities/Integrations'
import type { IContactPhone } from 'entities/Contacts'

export class ContactUnified extends ContactIntegrationBase<IResponseContactUnifiedIntegration> {
  integration_type: IIntegrationKey

  constructor(response: IResponseContactUnifiedIntegration) {
    super(response)

    makeAutoObservableSuper(this)

    this.integration_type = response.integration_type
    this.email = response.email

    this.national_number = response.phones['Phone'] || ''
    this.mobile_phone = response.phones['Mobile Phone'] || ''
    this.custom_phone = response.phones['Custom Phone'] || ''
    this.phone = this.params.number || ''
  }

  get phoneNumbers(): IContactPhone[] {
    const phones: IContactPhone[] = []

    if (this.national_number) {
      phones.push({
        field: 'Phone',
        type: 'phone',
        number: this.national_number,
      })
    }

    if (this.mobile_phone) {
      phones.push({
        field: 'Mobile phone',
        type: 'mobilephone',
        number: this.mobile_phone,
      })
    }

    if (this.custom_phone) {
      phones.push({
        field: 'Custom phone',
        type: 'third_phone',
        number: this.custom_phone,
      })
    }

    return phones
  }

  get params(): Partial<IParamsCreateContact> {
    return {
      ...this.integrationLinkDTOParams,
      contact_integration_id: String(this.integrationLinkDTOParams.contact_integration_id),
    }
  }

  get integrationLinkDTOParams(): Pick<
    IIntegrationLinkDTO,
    'email' | 'first_name' | 'last_name' | 'contact_integration_id' | 'phone_type' | 'number'
  > {
    const superParams = super.params
    return {
      email: superParams.email || '',
      first_name: superParams.first_name || '',
      last_name: superParams.last_name || '',
      contact_integration_id: superParams.contact_integration_id || '',
      phone_type: this.phoneNumbers[0]?.type || '',
      number: this.phoneNumbers[0]?.number || '',
    }
  }
  get number() {
    return formatPhoneNumberToInternational(this.phoneNumbers[0]?.number || '')
  }
}
